<div class="tw:w-full tw:px-[15px] tw:mx-auto" [ngClass]="{'tw:px-0': !includeContainerGutter}">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
    <div class="tw:flex-1 tw:px-[15px] tw:flex tw:flex-wrap">
      @for (student of students; track student) {
        <div class="card-holder tw:inline-flex tw:mr-8"
          (click)="selectStudent(student)">
          <div class="card tw:mb-4 student-card">
            @if (placementData?.lessonPlanTypeCode == 'Classic') {
              <div class="back-arrow-icon-container"
                data-toggle="tooltip" data-placement="top" title="Open Learner Session Area"
                >
                <div class="back-arrow-icon cursor-pointer"></div>
              </div>
            }
            <div class="card-body">
              <div class="tw:w-full tw:p-0 tw:m-0 tw:flex flex-column tw:h-full">
                <div class="tw:flex tw:items-start tw:-mx-[15px]">
                  <div class="tw:flex-1 tw:px-[15px]">
                    <h4 class="card-title tw:mt-1 tw:mb-3">{{student.studentFirstName}} {{student.studentLastName}}</h4>
                  </div>
                  @if (placementData?.lessonPlanTypeCode !== 'Classic') {
                    <div class="tw:px-[15px] tw:shrink-0 tw:pt-1">
                      <div class="padlock-icon-container cursor-pointer"
                        data-toggle="tooltip" data-placement="top" title="Generate Access"
                        (click)="$event.stopPropagation(); grantStudentAccess(student)">
                        <div class="padlock-icon"></div>
                      </div>
                    </div>
                  }
                </div>
                <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                  @for (attendance of student.attendanceInformationDisplayList; track attendance) {
                    <div class="tw:w-1/2 tw:px-[15px] tw:pr-2 tw:my-1">
                      <span class="badge badge-pill"
                        [ngClass]="getBadgeClass(attendance.description)">
                        {{attendance.count.trim()}}
                      </span>
                      <label class="tw:ml-2 tw:mt-1 font-12 tw:inline">{{attendance.description}}</label>
                    </div>
                  }
                  @if (student.cancellationAttendanceFound) {
                    <div class="tw:w-full tw:px-[15px]">
                      <label class="font-12">*(c) cancellation</label>
                    </div>
                  }
                </div>
                <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-4 tw:grow tw:content-end">
                  @if (student.sessionsStart != null) {
                    <div class="tw:w-full tw:px-[15px] tw:py-0 tw:mt-0 tw:mb-1">
                      <label class="tw:mb-0 font-12"><b>Session start: </b>{{student.sessionsStart | date: 'dd MMM yyyy'}}</label>
                    </div>
                  }
                  @if (student.sessionsEnd != null) {
                    <div class="tw:w-full tw:px-[15px] tw:py-0 tw:mt-0 tw:mb-1">
                      <label class="tw:mb-0 font-12"><b>Session end: </b>{{student.sessionsEnd | date: 'dd MMM yyyy'}}</label>
                    </div>
                  }
                </div>
                @if (placementData?.lessonPlanTypeCode !== 'Classic') {
                  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                    <div class="tw:w-full tw:px-[15px] font-12">
                      <ul class="tl-links">
                        <li class="tl-link  tl-link--view" (click)="viewStudentTimeline(student)">View timeline</li>
                        <li class="tl-link  tl-link--add"
                          (click)="$event.stopPropagation(); addMilestone(student)">
                          Add milestone
                        </li>
                        <!-- Temporarily hidden: Add a learning section
                        <li class="tl-link  tl-link--add" (click)="addLearningSection(student)">Add a learning section</li>
                        -->
                        <li class="tl-link"
                          [ngClass]="studentHasIlp(student) ? 'tl-link--ilp-view' : 'tl-link--ilp-create'"
                          (click)="$event.stopPropagation(); viewOrCreateIlp(student.studentId, placementId)">
                          {{ studentHasIlp(student) ? 'View ILP' : 'Create ILP' }}
                        </li>
                        <li class="tl-link  tl-link--add"
                          (click)="$event.stopPropagation(); newProgressReport(student.studentId, placementId)">
                          New progress report
                        </li>
                        <li class="tl-link  tl-link--view"
                          (click)="$event.stopPropagation(); viewProgressReports(student.studentId, placementId, student.studentFirstName + ' ' + student.studentLastName)">
                          View progress reports ({{ getProgressReportCount(student) }})
                        </li>
                      </ul>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
